let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ipWL6")).then(() => parcelRequire('7wEYc'));